// storageKey 是 enum，受 isolatedModules 限制无法用 import 的 const 初始化成员，故 key 在此保留
// 字面量。其中 HOMENSFWSTATE / USER 被预取（boot/SW）直接 import 复用（见
// packages/sw-prefetch/src/prefetch/constants.ts、constant/prefetch-user.ts）——本文件零 import 纯 enum，esbuild
// 打包 boot 时把用到的成员内联成字面量、tree-shake 其余，故能直接复用而无需另立常量 + CI 校验。
export enum storageKey {
  TOKEN = '/token',
  USER = '/user',
  HOMENSFWSTATE = 'homeNSFWState',
  SHOW_DOWNLOAD_STATE = 'showDownloadState',
  UNLOGGED_USER_SELECTED_LANGUAGE = 'UNLOGGED_USER_SELECTED_LANGUAGE', // 未登录用户选择的语言
  SESSION_ID = 'sessionId',
  TRACE_ID = 'traceId', // 用于风控追踪用户
  HALLOWEEN_TAG_POPUP_SHOWN = 'has_halloween_tag_popup_shown', // 万圣节tag弹窗是否已显示
  SELF_GENDER_SELECTION = 'selfGenderSelection',
  SHOW_FILTER_BADGE = 'show_filter_badge', // 首页筛选图标是否显示红点
  CLICKED_TAGS_WITH_BADGE = 'clicked_tags_with_badge', // 已点击过的带红点tag列表
}
